import { ChakraBox as Box, ChakraFlex as Flex, Text } from '@equip.health/ui';

type LegendPayload = {
  dataKey: string;
  color: string; // hex
};
export type LegendShadingEntry = {
  label: string;
  fill: string;
  fillOpacity?: number;
  stroke?: string;
  /**
   * Swatch dimensions. Default 18x10 renders a rectangle for shaded zones.
   * For vertical-line markers (e.g. "Today"), pass a narrow width like "2px"
   * with a taller height so the swatch reads as a line. (GX-3321)
   */
  swatchWidth?: string;
  swatchHeight?: string;
};
type LegendProps = {
  payload: LegendPayload[];
  shadingEntries?: LegendShadingEntry[];
  onHoverLine?: (line: string | null) => void;
  hoveredLine?: string | null;
};
export const AssessmentChartCardLegend = ({
  payload,
  shadingEntries,
  onHoverLine,
  hoveredLine,
}: LegendProps) => {
  return (
    <Flex
      alignItems="center"
      flexWrap="wrap"
      gap="12px 18px"
      justifyContent="center"
      paddingTop="10px"
    >
      {payload.map(({ dataKey, color }) => {
        const isHoverDimmed =
          hoveredLine !== null &&
          hoveredLine !== undefined &&
          hoveredLine !== dataKey;
        const opacity = isHoverDimmed ? 0.32 : 1;
        return (
          <Flex
            alignItems="center"
            key={dataKey}
            onMouseEnter={() => onHoverLine?.(dataKey)}
            onMouseLeave={() => onHoverLine?.(null)}
            opacity={opacity}
            transition="opacity 160ms ease"
          >
            <Box
              bgColor={color}
              borderRadius="10px"
              height="10px"
              marginRight="8px"
              width="10px"
            />
            <Text variant="body">{dataKey}</Text>
          </Flex>
        );
      })}
      {shadingEntries?.map(
        ({ label, fill, fillOpacity, stroke, swatchWidth, swatchHeight }) => (
          <Flex alignItems="center" key={`shading-${label}`}>
            <Box
              bgColor={fill}
              borderColor={stroke}
              borderRadius="2px"
              borderStyle={stroke ? 'solid' : undefined}
              borderWidth={stroke ? '1px' : 0}
              height={swatchHeight ?? '10px'}
              marginRight="8px"
              opacity={fillOpacity ?? 1}
              width={swatchWidth ?? '18px'}
            />
            <Text variant="body">{label}</Text>
          </Flex>
        ),
      )}
    </Flex>
  );
};
